var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("footer", { staticClass: "site-footer" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "footer-legal" }, [
      _c("div", { staticClass: "content-full-width flex" }, [
        _c("div", { staticClass: "copyright" }, [
          _c("p", [
            _vm._v("© Copyright " + _vm._s(_vm.year) + " Habit Health.")
          ]),
          _vm._v(" "),
          _c(
            "a",
            {
              attrs: {
                href: "http://www.brownpaperbag.co.nz/",
                target: "_blank"
              }
            },
            [_vm._v("\n            Web Design by Brownpaperbag\n          ")]
          )
        ]),
        _vm._v(" "),
        _vm._m(1),
        _vm._v(" "),
        _c("div", { staticClass: "social" }, [
          _c(
            "a",
            {
              attrs: { href: _vm.social_links.facebook_url, target: "_blank" }
            },
            [_c("img", { attrs: { src: "/images/fb.svg", alt: "" } })]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              attrs: { href: _vm.social_links.instagram_url, target: "_blank" }
            },
            [_c("img", { attrs: { src: "/images/ig.svg", alt: "" } })]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              attrs: { href: _vm.social_links.linked_in_url, target: "_blank" }
            },
            [_c("img", { attrs: { src: "/images/in.svg", alt: "" } })]
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "footer-links" }, [
      _c("div", { staticClass: "content-max-width" }, [
        _c("div", { staticClass: "menu flex" }, [
          _c("div", { staticClass: "links" }, [
            _c("a", { attrs: { href: "/sitemap" } }, [_vm._v("Sitemap")]),
            _vm._v(" "),
            _c("a", { attrs: { href: "/privacy-statement" } }, [
              _vm._v("Privacy Statement")
            ]),
            _vm._v(" "),
            _c("a", { attrs: { href: "/legal" } }, [_vm._v("Legal")])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "right" }, [
            _c("img", {
              staticClass: "shielded-logo",
              attrs: {
                src: "/images/custom-logo.png",
                id: "untraceable-element",
                alt: "Shielded Logo"
              }
            })
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "legal" }, [
      _c("img", {
        attrs: { src: "/images/footer-dark.svg", alt: "Habit Health logo" }
      })
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-50e1e017", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-50e1e017","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/frontend/js/components/Footer.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-50e1e017","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/frontend/js/components/Footer.vue
// module chunks = 0